angular.module('bmsApp.merrymaids.job')
	.controller('MMJobIndexSideCtrl', MMJobIndexSideCtrl);

MMJobIndexSideCtrl.$inject = [
	'$scope',
	'$state',
	'$q',
];

function MMJobIndexSideCtrl($scope, $state, $q) {
	let self = this;
	let handlers = {};

	angular.extend(self, {
		loading: null,
		handlers: handlers,
	});

	this.$onInit = () => {
		self.loading = true;
	};

	// Handlers --------------------------------------------------------------------------------------------------------
	$scope.$on('mmJobIndexChanged', (event, params) => {
		self.counts = params;
	});
}